"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveDefaultPlatformAccess = resolveDefaultPlatformAccess;
exports.canAccessPlatform = canAccessPlatform;
exports.normalizePlatformHeader = normalizePlatformHeader;
const platform_access_constants_js_1 = require("./platform-access.constants.js");
const case_workflow_helpers_js_1 = require("../case-workflow/case-workflow.helpers.js");
/**
 * Only CaseTrust businesses are restricted from Nucleus. Uses `resolveCaseWorkflowEnabled`
 * (not just `signupSource`) so a business flagged CASE via `caseWorkflowEnabled: true`
 * directly is treated the same as one flagged via `signupSource: "case-flow"`.
 */
function resolveDefaultPlatformAccess(body) {
    if ((0, case_workflow_helpers_js_1.resolveCaseWorkflowEnabled)({ caseWorkflowEnabled: body.caseWorkflowEnabled, signupSource: body.signupSource ?? undefined })) {
        return { handshakePlatformEnabled: true, nucleusPlatformEnabled: false };
    }
    return { handshakePlatformEnabled: true, nucleusPlatformEnabled: true };
}
function canAccessPlatform(business, platform) {
    if (!business)
        return false;
    if (platform === platform_access_constants_js_1.BusinessPlatform.NUCLEUS) {
        return business.nucleusPlatformEnabled !== false;
    }
    return business.handshakePlatformEnabled !== false;
}
function normalizePlatformHeader(value) {
    const raw = Array.isArray(value) ? value[0] : value;
    const normalized = String(raw ?? "")
        .trim()
        .toLowerCase();
    if (normalized === platform_access_constants_js_1.BusinessPlatform.HANDSHAKE || normalized === platform_access_constants_js_1.BusinessPlatform.NUCLEUS) {
        return normalized;
    }
    return undefined;
}
